module.exports = __webpack_public_path__ + "img/expostyle_1234_atoll_blue.05ed72ed.jpg";